import React, { useState, useEffect } from "react";
import PedigreeTree from "../elements/PedigreeTree";
import Carousel from "./Carousel";
import { sponsorService } from "../../api/sponsor.service";
import SponsorModal from "./SponsorModal";
import AddHorseModal from "../AddHorseModal";
import { addHorseAlerts } from "../../api/helpers";
import SourAlert from "../elements/SourAlert";
import useSourAlert from "../../hooks/useSourAlert";

const Step2 = ({
	handleSelected,
	setCredits,
	originalCredits,
	canGenerateReport,
	selected,
	horse,
	setHorse,
	sponsorIdToOpen,
	onBack,
	onContinue,
	completionLabel,
	selectionDetails,
	onSelectionDetailsChange,
}) => {
	const [sponsorId, setSponsorId] = useState(null);
	const [selectedSponsor, setSelectedSponsor] = useState(null);
	const [isOpenSponsor, setIsOpenSponsor] = useState(false);
	const [isAddHorseModalOpen, setIsAddHorseModalOpen] = useState(false);
	const [alertProps, showAlert] = useSourAlert();

	useEffect(() => {
		if (sponsorIdToOpen == null) return;

		setSponsorId(sponsorIdToOpen);
		setIsOpenSponsor(true);
	}, [sponsorIdToOpen]);

	const handleAddHorseResult = (result) => {
		if (result.type === 'success') {
			showAlert(addHorseAlerts.success);
		} else {
			showAlert(addHorseAlerts.error(result.message));
		}
	};

	const handleSponsorHorseSelect = (selectedHorse) => {
		const sponsoredHorse = {
			...selectedHorse,
			sponsor: {
				id: selectedSponsor.id,
				name: selectedSponsor.name,
				logo: selectedSponsor.logo,
			},
		};
		setHorse(sponsoredHorse);
		handleSelected(selectedHorse.id, "sire");
		onSelectionDetailsChange?.("sire", sponsoredHorse);
		setIsOpenSponsor(false);
	};

	useEffect(() => {
		if (sponsorId !== null) {
			setSelectedSponsor(null);
			sponsorService
				.retrieve(sponsorId)
				.then((response) => {
					setSelectedSponsor(response);
					setIsOpenSponsor(true);
				})
				.catch((err) => {
					console.error("Error fetching sponsor:", err);
				});
		}
	}, [sponsorId]);

	return (
		<div className="component-card pedigree-step-card">
			<div className="pedigree-step-card__content">
				<h2 className="subtitle is-black mb-5">Select parents</h2>
				<p className="pedigree-step-help mb-20">
					Select both parents to create a report. If a parent is unknown,
					add its parents instead.
				</p>

			<div className="pedigree-sponsor-tools">
				<div className="pedigree-sponsor-tools__label">
					<i className="fas fa-award" aria-hidden="true" />
					<span>Sponsored horses</span>
					<span className="pedigree-sponsor-tooltip">
						<button
							type="button"
							className="pedigree-sponsor-tooltip__trigger"
							aria-label="What is a sponsored horse?"
							aria-describedby="sponsored-horse-help"
						>
							<i className="fas fa-info-circle" aria-hidden="true" />
						</button>
						<span
							id="sponsored-horse-help"
							className="pedigree-sponsor-tooltip__content"
							role="tooltip"
						>
							Sponsored horses are free to run.
						</span>
					</span>
				</div>
				<Carousel
					setSponsorId={setSponsorId}
					setIsOpenSponsor={setIsOpenSponsor}
				/>
			</div>
				<div data-tour-id="pedigree-tree">
					<PedigreeTree
						onSelect={handleSelected}
						selectedHorses={selected}
						setSponsorId={setSponsorId}
						setIsOpenSponsor={setIsOpenSponsor}
						setCredits={setCredits}
						originalCredits={originalCredits}
						horse={horse}
						setHorse={setHorse}
						onAddNewHorse={() => setIsAddHorseModalOpen(true)}
						selectionDetails={selectionDetails}
						onSelectionDetailsChange={onSelectionDetailsChange}
					/>
				</div>
				{!canGenerateReport && (
					<p className="pedigree-inline-guidance" role="status">
						<i className="fas fa-info-circle mr-10" aria-hidden="true" />
						{completionLabel}
					</p>
				)}
				<div className="pedigree-step-actions">
					<button type="button" className="button outline" onClick={onBack}>
						<i className="fas fa-arrow-left mr-10" aria-hidden="true" />
						Back
					</button>
				<button
					type="button"
					onClick={onContinue}
					className="button"
					disabled={!canGenerateReport}
					data-tour-id="pedigree-review-button"
				>
					{completionLabel}
					<i className="fas fa-arrow-right ml-10" aria-hidden="true" />
				</button>
				</div>
			</div>
			<SponsorModal
				isOpenSponsor={isOpenSponsor}
				selectedSponsor={selectedSponsor}
				setIsOpenSponsor={setIsOpenSponsor}
				onSelectHorse={handleSponsorHorseSelect}
			/>
			<AddHorseModal
				isOpen={isAddHorseModalOpen}
				onClose={() => setIsAddHorseModalOpen(false)}
				onResult={handleAddHorseResult}
			/>
			<SourAlert {...alertProps} />
		</div>
	);
};

export default Step2;
